import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../utils/api';

export default function ResetPassword() {
  const [searchParams]            = useSearchParams();
  const token                     = searchParams.get('token') || '';
  const navigate                  = useNavigate();
  const [password, setPassword]   = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [show, setShow]           = useState(false);
  const [loading, setLoading]     = useState(false);
  const [msg, setMsg]             = useState('');
  const [error, setError]         = useState('');

  const inputStyle = {
    width: '100%', padding: '12px 14px',
    border: '1.5px solid #2E4A40', borderRadius: 10,
    fontSize: 15, background: '#0D1311', color: '#F4F7F5',
    fontFamily: 'inherit', boxSizing: 'border-box', outline: 'none',
  };

  const labelStyle = {
    display: 'block', fontSize: 12, fontWeight: 600, color: '#9FAAA5',
    marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.5px',
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres'); return;
    }
    if (password !== confirmar) {
      setError('Las contraseñas no coinciden'); return;
    }
    setLoading(true);
    try {
      await api.post('/auth/reset', { token, password });
      setMsg('✅ Contraseña actualizada correctamente. Ahora puedes iniciar sesión.');
    } catch (err) {
      setError(err.response?.data?.error || 'Token inválido o expirado. Solicita un nuevo enlace.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div style={pageStyle}>
        <div style={cardStyle}>
          <p style={{ color: '#EF4444', textAlign: 'center' }}>
            Enlace inválido. Solicita un nuevo enlace de recuperación.
          </p>
          <button onClick={() => navigate('/login')} style={btnStyle()}>
            Ir al login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={pageStyle}>
      <div style={{ textAlign: 'center', marginBottom: 28 }}>
        <div style={{
          width: 90, height: 90, background: 'white', borderRadius: '50%',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 14px', boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
          overflow: 'hidden', padding: 8,
        }}>
          <img src="/logo_solvert.jpg" alt="Solvert"
            style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
        </div>
        <h1 style={{ color: 'white', margin: 0, fontSize: 24, fontWeight: 800 }}>Solvert App</h1>
      </div>

      <div style={cardStyle}>
        <h2 style={{ margin: '0 0 6px', fontSize: 18, fontWeight: 700, color: '#F4F7F5' }}>
          Nueva contraseña
        </h2>
        <p style={{ margin: '0 0 20px', fontSize: 13, color: '#9FAAA5' }}>
          Elige una contraseña segura para tu cuenta
        </p>

        {error && (
          <div style={{ background: '#2D0F0F', color: '#EF4444', padding: '10px 14px',
            borderRadius: 10, fontSize: 13, marginBottom: 16, borderLeft: '4px solid #c62828' }}>
            {error}
          </div>
        )}

        {msg ? (
          <div style={{ background: '#12382D', color: '#4CAF50', padding: '14px',
            borderRadius: 10, fontSize: 14, marginBottom: 20, textAlign: 'center',
            borderLeft: '4px solid #0F6E56' }}>
            {msg}
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ width: '100%' }}>
            <div style={{ marginBottom: 14 }}>
              <label style={labelStyle}>Nueva contraseña</label>
              <div style={{ position: 'relative' }}>
                <input
                  type={show ? 'text' : 'password'}
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="Mínimo 6 caracteres"
                  required
                  style={{ ...inputStyle, paddingRight: 80 }}
                />
                <button type="button" onClick={() => setShow(!show)}
                  style={{ position: 'absolute', right: 12, top: '50%',
                    transform: 'translateY(-50%)', background: 'none',
                    border: 'none', cursor: 'pointer', fontSize: 12,
                    fontWeight: 600, color: '#4CAF50', padding: '4px 6px' }}>
                  {show ? 'Ocultar' : 'Mostrar'}
                </button>
              </div>
            </div>

            <div style={{ marginBottom: 20 }}>
              <label style={labelStyle}>Confirmar contraseña</label>
              <input
                type={show ? 'text' : 'password'}
                value={confirmar}
                onChange={e => setConfirmar(e.target.value)}
                placeholder="Repite la contraseña"
                required
                style={inputStyle}
              />
            </div>

            <button type="submit" disabled={loading} style={btnStyle(loading)}>
              {loading ? 'Guardando...' : 'Guardar nueva contraseña'}
            </button>
          </form>
        )}

        <button onClick={() => navigate('/login')} style={{
          background: 'none', border: 'none', color: '#4CAF50',
          fontSize: 13, cursor: 'pointer', marginTop: 16,
          width: '100%', textAlign: 'center',
        }}>
          ← Volver al login
        </button>
      </div>
    </div>
  );
}

const pageStyle = {
  minHeight: '100vh',
  background: 'linear-gradient(160deg, #0a5c47 0%, #0f6e56 50%, #1d9e75 100%)',
  display: 'flex', flexDirection: 'column',
  alignItems: 'center', justifyContent: 'center',
  padding: '24px 20px',
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
};

const cardStyle = {
  background: '#111714', borderRadius: 20, padding: '28px 24px 24px',
  width: '100%', maxWidth: 360,
  border: '1px solid #24312B',
  boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
};

const btnStyle = (loading = false) => ({
  display: 'block', width: '100%', padding: '14px',
  background: loading ? '#2A332F' : '#0F6E56',
  color: 'white', border: 'none', borderRadius: 12,
  fontSize: 16, fontWeight: 700, cursor: 'pointer',
  textAlign: 'center', boxSizing: 'border-box',
});
